import { render, staticRenderFns } from "./btnPlus.vue?vue&type=template&id=ddd26ce6"
import script from "./btnPlus.vue?vue&type=script&lang=js"
export * from "./btnPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports